import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ListProductVpsComponent from "../../../components/Customer/products/ListProductVpsComponent";

const CreateProductPage = () => {

    const params = useParams();
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/');
    }

    return <ListProductVpsComponent groupProductId={ params.groupProductId } shouldRedirect={ () => redirect() } />;
}

export default CreateProductPage;